import { rankingData } from '@/mocks/comicData';

export default function Ranking() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[720px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-10 text-center">
          {rankingData.title}
        </h2>
        <div className="bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
          {rankingData.items.map((item, idx) => (
            <div
              key={idx}
              className={`flex items-center gap-4 p-4 md:p-5 cursor-pointer hover:bg-background-100 transition-colors ${
                idx < rankingData.items.length - 1 ? 'border-b border-background-200/70' : ''
              }`}
            >
              <div
                className={`w-8 h-8 flex items-center justify-center rounded-lg font-heading font-bold text-sm flex-shrink-0 ${
                  item.rank === 1
                    ? 'bg-primary-500 text-background-50'
                    : item.rank === 2
                    ? 'bg-accent-500 text-background-50'
                    : item.rank === 3
                    ? 'bg-secondary-500 text-background-50'
                    : 'bg-background-100 text-foreground-500'
                }`}
              >
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 whitespace-nowrap overflow-hidden text-ellipsis">
                  {item.title}
                </h3>
                <span className="text-[11px] text-foreground-500">{item.tag}</span>
              </div>
              <div className="flex-shrink-0 text-right">
                <span className="text-xs md:text-sm font-medium text-accent-600 whitespace-nowrap">
                  {item.heat}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}